import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {  matArrowForward, matArrowDownward } from "@quasar/extras/material-icons";
import { isIEorEdge } from "@/utils/isIEorEdge";
import { MatrixTableData } from "@/models/MatrixTableData";
import { ModeTemplate } from "@/models/Mode";
import { translate } from "@/utils/translation";

@Component
export default class ProductMatrix extends Vue {
  @Prop() private title!: number;

  @Prop() private type!: number;

  @Prop() private items: Array<any> | undefined;

  @Prop() private loading!: boolean;

  @Prop() private scrollEnable!: boolean;

  @Prop() private mode!: ModeTemplate;

  @Prop({default: ['Height', 'Width']}) private axisNames!: string[];

  private levels: any[] = []
  private horizontalAxis: any[] = []
  private verticalAxis: string[] = []
  private heatoutputData: MatrixTableData[] = [];

  private matArrowRight = "";
  private matArrowDownward = "";

  private showTooltip = false;

  public created() {
    this.matArrowRight = matArrowForward;
    this.matArrowDownward = matArrowDownward;
  }

  @Watch('items')
  public onItemsChange(val: any[]) {
      if(val === undefined)
        return;
      this.verticalAxis = this.getDistinctFieldValues(val, "ItemWidth");
      this.levels = this.initLevels(this.mode.SupportedLevels, this.verticalAxis.length ?? 1);
      this.horizontalAxis = this.initHorizontalAxis(val, "ItemHeight");
      this.heatoutputData = this.initData(val, this.verticalAxis, "ItemWidth");
  }

  private initLevels(supportedLevels: string[], rowsCount: number) {
    return supportedLevels.map(level => ({
      name: level,
      count: Number(this.items?.length)/rowsCount/supportedLevels.length
    }))
  }

  private initHorizontalAxis(items: any[], fieldname: string): any[] {
    if(!Array.isArray(items))
      return [];
    const widths = new Set(items?.map(x => x[fieldname]))
    const output: any[] = [];
    this.levels.forEach(mode => {
      widths.forEach(w => output.push({
        mode: mode.name,
        value: w
      }))
    })
    return output;
  }

  private getDistinctFieldValues(items: any[], fieldname: string): string[] {
    const x = items?.map(x => x[fieldname]);
    return Array.from(new Set(x));
  }

  private initData(items: any[], rows: any[], filterFieldName: string): MatrixTableData[] {
    return rows.map(row => ({
      key: row,
      values: items?.filter(x => x[filterFieldName] == row).map(x => ({
        value: x.HeatOutput,
        isCompatible: x.Compatible,
        mode: x.Mode
      }))
    }) as MatrixTableData);
  }

  private pagination = {
    page: 1,
    rowsPerPage: 0 // 0 means all rows
  };

  public get hasVariants(): boolean {
    return true;
  }

  public isHighlighted(m: any): boolean {
    return this.mode.Highlighted === m.name;
  }

  public highlightClass(index: number, array: any[]) {
    const obj = array[index];
    const modes = array.filter(x => x.mode === this.mode.Highlighted)
    if(modes.includes(obj)) {
      const i = modes.findIndex(x => x === obj)
      if(modes.length == 1) {
        return 'highlight-left highlight-right'
      }
      else if(i == 0)
        return 'highlight-left';
      else if(i == modes.length - 1)
        return 'highlight-right'
      return 'highlight'
    }
  }

  public Translate(text: string): string {
    return translate(text);
  }

  private _isIEorEdge() {
    return isIEorEdge();
  }
}
